import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { client } from "../../Clients";

export interface ContentTypeEntry {
	key: string;
	title: string;
	version?: string;
	description?: string | null;
	isSingleton?: boolean;
	schema: any;
	fields?: any;
}

export interface ContentTypesState {
	items: Record<string, ContentTypeEntry>;
	loading: boolean;
	error?: string | null;
	initialized: boolean;
}

const initialState: ContentTypesState = {
	items: {},
	loading: false,
	error: null,
	initialized: false
};

const contentTypesSlice = createSlice({
	name: "contentTypes",
	initialState,
	reducers: {
		setLoading(state, action: PayloadAction<boolean>) {
			state.loading = action.payload;
		},
		setContentTypes(state, action: PayloadAction<ContentTypeEntry[]>) {
			state.items = action.payload.reduce<Record<string, ContentTypeEntry>>((acc, entry) => {
				acc[entry.key] = entry;
				return acc;
			}, {});
			state.initialized = true;
			state.error = null;
		},
		setError(state, action: PayloadAction<string | null>) {
			state.error = action.payload;
			state.loading = false;
		}
	}
});

export const { setLoading, setContentTypes, setError } = contentTypesSlice.actions;
export const { reducer } = contentTypesSlice;

export const fetchContentTypes = () => async (dispatch: Dispatch) => {
	dispatch(setLoading(true));
	try {
		const response = await client.contentTypes.apiContentTypesGet();
		const types = (response.data ?? []) as ContentTypeEntry[];
		dispatch(setContentTypes(types));
	} catch (err: any) {
		dispatch(setError(err?.message ?? "Unable to load content types"));
	} finally {
		dispatch(setLoading(false));
	}
};

